import Vue from 'vue'
import MagAddFiltersDialog from './MagAddFiltersDialog.vue';

Vue.component('MagAddFiltersDialog', MagAddFiltersDialog);
